import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const RemoveHelperTextStyled = styled(Text)`
  color: ${(props) => props.theme.colors.text.secondary};
`
